import io from "socket.io-client";
//const socket = io("http://localhost:3001") 
const socket = 0;
export default socket;